import FormattedMessage from 'I18n/components/FormattedMessage';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const EmailV3RenderingTooltipMessage = () => {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("strong", {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "EmailV3RenderingTooltipMessage.title"
      })
    }), /*#__PURE__*/_jsx(View, {
      marginBlockStart: "100",
      as: "div",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "EmailV3RenderingTooltipMessage.description"
      })
    })]
  });
};
export default EmailV3RenderingTooltipMessage;